import React from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../../../../redux/hooks';
import SectionHeading from '../../../../../components/SectionHeading';
import { queryMeasuresInfo } from '../../../../../components/KubitTooltip/globalTooltips';
import { theme } from '../../../../../styles/theme';

const CompoundMeasureName = styled.div`
  flex: 0 0 auto;
  position: relative;
  margin-left: 8px;
  padding-left: 8px;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background-color: ${theme.colors.secondary800};
    transform: translateY(-50%);
  }
`;

const QueryMeasureHeading = () => {
  const compoundMeasureName = useAppSelector(
    (state) => state.builder.compoundMeasureName,
  );

  return (
    <SectionHeading heading="Measure(s)" tooltipOption={queryMeasuresInfo}>
      {compoundMeasureName && (
        <CompoundMeasureName>{compoundMeasureName}</CompoundMeasureName>
      )}
    </SectionHeading>
  );
};

export default QueryMeasureHeading;
